import { Button, Table } from "antd";
import { useQuery } from "@tanstack/react-query";
import { useLocation } from "react-router-dom";
import WarehouseService from "../../services/Warehouses/WarehouseService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/pro-duotone-svg-icons";
import { getRowClassName } from "../../helpers/common";

const WarehouseDocksTable = ({ handleIsModifying, handleDockIdChange }) => {
  const { state: { warehouseId } } = useLocation();
  const { data: docks, isLoading } = useQuery({
    queryKey: [warehouseId, "docks"],
    queryFn: async () => await WarehouseService.getDocksByWarehouseId(warehouseId),
    select: (data) => data.map(dock => ({ ...dock, warehouseId })),
  });

  const handleEdit = (id) => {
    handleIsModifying();
    handleDockIdChange(id);
  };

  const columns = [
    {
      title: "",
      dataIndex: "id",
      key: "id",
      width: "10%",
      render: (id) => (
        <Button type="link" className="group" onClick={() => handleEdit(id)}>
          <FontAwesomeIcon
            icon={faPenToSquare}
            className="text-xl text-black block p-3 hover:text-cyan-500"
          />
        </Button>
      ),
    },
    {
      title: "Name",
      width: "30%",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
    },
  ];

  return (
    <Table dataSource={docks}
           columns={columns}
           rowKey="id"
           loading={isLoading}
           size="small"
           scroll={{ y: 320 }}
           rowClassName={getRowClassName}
           pagination={false} />
  );
};

export default WarehouseDocksTable;